<!-- Instagram search results (reel) -->
<div class="mst">
  <div class="mst-screen igr-screen">
    <app-meta-creative class="mst-creative" [src]="data.creative" [kind]="data.creativeKind" slot="story"></app-meta-creative>
    <div class="mst-scrim"></div>
    <div class="igr-scrim"></div>

    <div class="igr-top">
      <i class="bi bi-chevron-left igr-back"></i>
      <span class="igr-term">[Search term]</span>
    </div>

    <div class="igr-actions">
      <i class="bi bi-heart"></i>
      <i class="bi bi-chat"></i>
      <i class="bi bi-arrow-repeat"></i>
      <i class="bi bi-send"></i>
      <i class="bi bi-three-dots"></i>
    </div>

    <a class="igr-copy" [attr.href]="data.url || null" target="_blank" rel="noopener noreferrer">
      <div class="igr-identity">
        <img class="igr-avatar" [src]="avatar" alt="" />
        <div>
          <div class="igr-name">{{ accountName }}<i class="bi bi-patch-check-fill igr-badge"></i></div>
          <div class="igr-label">Oglas</div>
        </div>
      </div>
      <div class="igr-caption">{{ primaryText.text }}<span *ngIf="primaryText.truncated"> ...</span></div>
    </a>
  </div>
</div>
